import { Route } from "@acri-tools/react-tools/utils/menu"

/**
 * route - the rect router dom route
 * mainMenu - MOBILE => if its on the nav bar
 * loggedIn - if the user needs to be logged in to see this route
 * iconOnly - if it only shows the route
 * adminOnly - admin only route
 */
const routes: Array<Route> = [
    {
        route: "/",
        name: "home",
        icon: "fas fa-home",
        mainMenu: true,
        loggedIn: false,
        iconOnly: true,
    },
    {
        route: "/services",
        name: "services",
        icon: "fas fa-project-diagram",
        mainMenu: true,
        loggedIn: false,
    },
    {
        name: "archive content",
        icon: "fas fa-archive",
        route: "/archive-content",
        mainMenu: true,
    },
    {
        name: "DIS",
        icon: "fas fa-database",
        route: "/DIS",
        mainMenu: true,
        // subMenu:[
        //     {
        //         name: "about",
        //         icon: "fas fa-info-circle",
        //         route: "/DIS/about"
        //     },
        //     {
        //         name: "Monthly Executive Summary",
        //         icon: "fas fa-list-ul",
        //         route: "/DIS/monthly-executive-summary"
        //     },
        // ]
    },
    {
        // route: "/",
        name: "ingestion monitoring",
        icon: "fas fa-desktop",
        mainMenu: true,
        subMenu: [
            {
                name: "historical data",
                icon: "fas fa-calendar-alt",
                route: "/ingestion-monitoring/historical-data"
            },
            {
                name: "live missions",
                icon: "fas fa-satellite",
                route: "/ingestion-monitoring/live-missions"
            },
            {
                name: "online missions",
                icon: "fas fa-broadcast-tower",
                route: "/ingestion-monitoring/online-missions"
            },
            {
                name: "throughput lm/om",
                icon: "fas fa-external-link-alt",
                route: "/ingestion-monitoring/throughput-lm-om"
            }
        ]
    },
    // {
    //     name: "projects",
    //     icon: "fas fa-desktop",
    //     mainMenu:true
    // },
    {
        name: "retrieval status",
        icon: "fas fa-satellite-dish",
        mainMenu: true,
        route: "/retrieval-status"
    },
    {
        name: "data maintenance",
        icon: "fas fa-tools",
        mainMenu: true,
        route: "/data-maintenance"
    },
    {
        name: "projects",
        icon: "fas fa-clipboard-list",
        mainMenu: true,
        route: "/projects"
    },
    {
        name: "ftp",
        icon: "fas fa-circle-down",
        mainMenu: true,
        loggedIn: true,
        route: "/Ftp"
    },
    {
        name: "news",
        icon: "fas fa-newspaper",
        mainMenu: true,
        route: "/news"
    },
    {
        name: "about us",
        icon: "fas fa-info-circle",
        mainMenu: true,
        route: "/about-us"
    },
    {
        // route: "/",
        name: "internal",
        icon: "fas fa-users",
        mainMenu: true,
        loggedIn: true,
        subMenu: [
            {
                name: "contacts",
                icon: "fas fa-users",
                route: "/internal/contacts"
            },
            {
                name: "minutes",
                icon: "fas fa-clock",
                route: "/internal/minutes"
            },
            {
                name: "reports",
                icon: "fas fa-file",
                route: "/internal/reports"
            },
            {
                name: "retrieval forms",
                icon: "fas fa-clipboard",
                route: "/internal/retrieval-forms"
            },
            {
                name: "deliveries",
                icon: "fas fa-truck",
                route: "/internal/deliveries"
            },
            {
                name: "media status",
                icon: "fas fa-image",
                route: "/internal/media-status"
            },
            {
                name: "actions",
                icon: "fas fa-asterisk",
                href: "https://redmine.acri-cwa.fr/redmine/projects/damps-esa"
            },
            {
                name: "ticketing system",
                icon: "fas fa-cogs",
                href: "https://glpi-damps.acri-cwa.fr/front/ticket.php"
            },
            {
                name: "Damps Database",
                icon: "fas fa-database",
                route: "/internal/damps-database"
            },
            {
                name: "KPI",
                icon: "fas fa-chart-area",
                route: "/internal/KPI"
            },
        ]
    },
    {
        route: "/admin",
        name: "admin",
        icon: "fas fa-user-shield",
        mainMenu: true,
        loggedIn: true,
        adminOnly: true,
        iconOnly: false,
    },
]
export default routes